import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {isEmpty} from 'lodash/lang';
import {Tooltip} from '@material-ui/core';
import {Edit as EditIcon, Delete as DeleteIcon, Send as SendIcon} from '@material-ui/icons';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager, DeletionConfirmBox} from 'components/common';
import {buildUserFullName} from 'utils/common';

const buildInvitationRecords = (invitations) => {
  const sortedIds = invitations.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((invitationId) => {
        const invitation = invitations[invitationId];
        const {invitee} = invitation;
        return {
          record: invitation,
          id: invitationId,
          email: invitee.email,
          firstName: invitee.firstName,
          lastName: invitee.lastName,
          role: invitee.role,
          school: isEmpty(invitation.school) ? '' : invitation.school.name,
          classroom: isEmpty(invitation.classroom) ? '' : invitation.classroom.name,
          invitedBy: buildUserFullName(invitation.invitedBy),
          actions: '',
        };
      });
};

const buildInvitationSettings = () => ({
  email: {
    fieldText: 'Email',
    sortable: true,
  },
  firstName: {
    fieldText: 'First Name',
  },
  lastName: {
    fieldText: 'Last Name',
  },
  role: {
    fieldText: 'Role',
  },
  school: {
    fieldText: 'School',
    formatData: (cell, row) => (cell ? <Link to={`/schools/${row.record.school.id}`}>{cell}</Link> : ''),
  },
  classroom: {
    fieldText: 'Classroom',
    formatData: (cell, row) => (cell ? <Link to={`/classroom/${row.record.classroom.id}`}>{cell}</Link> : ''),
  },
  invitedBy: {
    fieldText: 'Invited By',
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row, restProps) => (
      <span className="table-actions">
        <EditIcon className="cursor-pointer" onClick={() => restProps.showUpdateModal(row.record)} />
        {restProps.canDeleteRow && (
          <DeleteIcon className="cursor-pointer" onClick={() => restProps.showDeletionConfirmBox(row)} />
        )}
        {row.email && restProps.resendInvitation && (
          <Tooltip title="Resend Invitation Email" placement="top">
            <SendIcon className="cursor-pointer" onClick={() => restProps.resendInvitation(row)} />
          </Tooltip>
        )}
      </span>
    ),
  },
});

class InvitationTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
    onDeleteActionClick: PropTypes.func,
    showUpdateModal: PropTypes.func.isRequired,
    resendInvitation: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      invitationToRemove: {},
    };
    this.showDeletionConfirmBox = this.showDeletionConfirmBox.bind(this);
    this.sortingManager = new SortingManager();
  }

  showDeletionConfirmBox(invitation) {
    this.setState(
      {
        invitationToRemove: invitation,
      },
      () => {
        ReactDOM.findDOMNode(this.deletionConfirmBoxRef)
          .querySelector('.btn-show-confirm')
          .click();
      },
    );
  }

  render() {
    const {
      recordPages,
      onSortableFieldClick,
      onDeleteActionClick,
      hiddenFields,
      showUpdateModal,
      resendInvitation,
    } = this.props;
    const invitations = recordPages[recordPages.currentPage] || {};
    const records = buildInvitationRecords(invitations);
    const settings = buildInvitationSettings();
    return [
      onDeleteActionClick && (
        <DeletionConfirmBox
          key="DeletionConfirmBox"
          ref={(ref) => (this.deletionConfirmBoxRef = ref)}
          itemName="invitation"
          deleteAction={() => onDeleteActionClick(this.state.invitationToRemove)}
          DeleteButton="span"
        />
      ),
      <KluwellTableCore
        {...{
          key: 'KluwellTableCore',
          records,
          settings,
          sortingManager: this.sortingManager,
          onSortableFieldClick,
          hiddenFields,
          canDeleteRow: !!onDeleteActionClick,
          showDeletionConfirmBox: this.showDeletionConfirmBox,
          showUpdateModal,
          resendInvitation,
        }}
      />,
    ];
  }
}

export default withKluwellTableWrapper(InvitationTableCore);
